import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { useGetSalesPartnerListQuery } from "@/redux/partnerApi";

export const SalesPartnersPopup = ({ layer = true, onClose, formData, setFormData, onSalesPartnerSelect }) => {
    const [query, setQuery] = useState("");
    const [selectedPartner, setSelectedPartner] = useState(null);

    const { data: partnerData, refetch } = useGetSalesPartnerListQuery();

    const handleSearch = () => {
        refetch();
    };

    const handleSelectPartner = (vehicle) => {
        setSelectedPartner(vehicle);
    };

    const handleConfirm = () => {
        if (!selectedPartner) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: "영업자를 선택하세요.",
            }));
            return;
        }
        onSalesPartnerSelect(selectedPartner);
        onClose();
    };

    useEffect(() => {
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>

            <div className="popup service-popup">
                <div className="popup-head">
                    <div className="head-tit">
                        <span className="tit-main">영업자 선택</span>
                    </div>
                    <div className="btn-close" onClick={onClose}></div>
                </div>
                <div className="popup-content">
                    <div className="table-container">
                        <div className="table-filter">
                            <div className="filter-row">
                                <div className="filter-item">
                                    <div className="item-content">
                                        <div className="item-input">
                                            <input
                                                type="text"
                                                placeholder="입력"
                                                value={query || ""}
                                                onChange={(e) => setQuery(e.target.value)}
                                            />
                                        </div>
                                        <div className="item-buttons">
                                            <button type="button" className="btn-search" onClick={handleSearch}>
                                                검색
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="table-content">
                            <div className="table-wrapper">
                                <div className="table">
                                    <table>
                                        <colgroup>
                                            <col width={"12%"} />
                                            <col width={"37%"} />
                                            <col width={"24%"} />
                                            <col width={"27%"} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">선택</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">영업자명</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">담당자</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">연락처</div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {partnerData && partnerData.data && partnerData.data.length > 0 ? (
                                                partnerData.data.map((partner) => (
                                                    <tr key={partner.id}>
                                                        <td>
                                                            <div className="cell" style={{ height: "100%" }}>
                                                                <div className="input-checkbox">
                                                                    <div className="checkbox" style={{ display: "flex" }}>
                                                                        <input
                                                                            type="radio"
                                                                            name="selectedPartner"
                                                                            id={`selectedPartner-${partner.id}`}
                                                                            checked={selectedPartner?.id === partner.id}
                                                                            onChange={() => handleSelectPartner(partner)}
                                                                        />
                                                                        <label htmlFor={`selectedPartner-${partner.id}`}></label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">
                                                                    {partner.address} {partner.addressDetail}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{partner.name}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{partner.phone}</div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4">영업자 데이터가 없습니다.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-bottom">
                    <button type="button" className="btn btn-primary btn-cancel" onClick={onClose}>
                        취소
                    </button>
                    <button type="button" className="btn btn-primary btn-confirm" onClick={handleConfirm}>
                        완료
                    </button>
                </div>
            </div>
        </>,
        document.body
    );
};
